/** The controller surface this wiring needs. */
type FlushTarget = { flushNow(): void };

/** The listener surface the wiring binds to (injectable for tests — no jsdom in this package). */
export type ListenerTarget = Pick<Document, 'addEventListener' | 'removeEventListener'>;

/**
 * Bind the shared `visibilitychange`(→hidden) + `beforeunload` flush pair used by both the
 * per-user and org layer-config sync wiring, and return a teardown that removes exactly those
 * two listeners. Extracted so the two hooks' divergent bits (router nav, teardown flush) stay
 * local to each hook while this common part is tested once.
 */
export function bindVisibilityAndUnloadFlush(
  controller: FlushTarget,
  documentTarget: ListenerTarget & { hidden: boolean },
  windowTarget: ListenerTarget,
): () => void {
  const onVisibilityChange = () => {
    if (documentTarget.hidden) controller.flushNow();
  };
  const onBeforeUnload = () => {
    controller.flushNow();
  };

  documentTarget.addEventListener('visibilitychange', onVisibilityChange);
  windowTarget.addEventListener('beforeunload', onBeforeUnload);

  return () => {
    documentTarget.removeEventListener('visibilitychange', onVisibilityChange);
    windowTarget.removeEventListener('beforeunload', onBeforeUnload);
  };
}
